import { ExceptionOutlined, FileProtectOutlined, WarningOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import React from 'react';
import theme from 'shared/constants/theme.json';
import { exceededLicenseLimit, isLicenseTrial } from 'shared/utils/license';
import { dayjs } from 'shared/utils/date';

const LicenseStatus = ({ license, currentUsage }) => {
  const currentAboveLimit = currentUsage?.some(u => exceededLicenseLimit(u.current, u.limit));
  const estimatedAboveLimit = !currentAboveLimit && currentUsage?.some(u => exceededLicenseLimit(u.estimated, u.limit));
  const isTrial = isLicenseTrial(license);

  return license ? (
    <Space>
      {currentAboveLimit && (
      <Space>
        <ExceptionOutlined style={{ color: theme['error-color'] }} />
        <span style={{ color: theme['error-color'] }}>Exceeded limits</span>
      </Space>
      )}
      {estimatedAboveLimit && (
      <Space>
        <WarningOutlined style={{ color: theme['warning-color'] }} />
        <span style={{ color: theme['warning-color'] }}>Usage estimated to exceed limits</span>
      </Space>
      )}
      {isTrial && (
      <Space>
        <WarningOutlined style={{ color: theme['warning-color'] }} />
        <span>
          {dayjs(license.endDate).diff(dayjs(), 'days')}
          {' '}
          days remaining on trial
        </span>
      </Space>
      )}
      {!isTrial && !currentAboveLimit && !estimatedAboveLimit && (
      <Space>
        <FileProtectOutlined style={{ color: theme['success-color'] }} />
        License active
      </Space>
      )}
    </Space>
  ) : (
    <Space style={{ color: theme['error-color'] }}>
      <ExceptionOutlined />
      No license
    </Space>
  );
};

export default LicenseStatus;
